// src/roles.js
// Único lugar donde se definen las cuentas con acceso al panel.
// Para cambiar una cuenta, alcanza con modificar el correo acá.

export const ADMIN_EMAIL = "reservas.cuchillaalta@gmail.com"; // acceso total
export const COBROS_EMAIL = "cobranzas.cuchillaalta@gmail.com"; // solo pestaña Pagos

const norm = (email) => (email || "").trim().toLowerCase();

// Admin: todo el panel + privilegios al reservar en nombre de otros
export const esAdmin = (usuario) => norm(usuario?.email) === ADMIN_EMAIL;

// Cobros: solo la pestaña Pagos del panel; para el resto es un usuario común
export const esCobros = (usuario) => norm(usuario?.email) === COBROS_EMAIL;

// ¿Puede entrar al panel?
export const puedeVerPanel = (usuario) => esAdmin(usuario) || esCobros(usuario);

// Nombre legible de quién hizo un cambio, a partir del correo guardado
export const etiquetaCuenta = (email) => {
  const e = norm(email);
  if (!e) return "";
  if (e === ADMIN_EMAIL) return "Admin";
  if (e === COBROS_EMAIL) return "Cobros";
  return email;
};
